import VisitorIcon from '@material-ui/icons/People';

import VisitorList from './VisitorList';
import VisitorCreate from './VisitorCreate';
import VisitorEdit from './VisitorEdit';

export default {
  list: VisitorList,
  create: VisitorCreate,
  edit: VisitorEdit,
  icon: VisitorIcon,
};
